import React, { FunctionComponent, memo, ReactElement } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { NavigationBarButtonProps } from '..'

export type NavigationBarButtonWithBackgroundProps = {
    /** Add option to modify horizontal margin */
    marginX?: number
} & NavigationBarButtonProps

const NavigationBarButtonWithBackground: FunctionComponent<
    NavigationBarButtonWithBackgroundProps
> = ({ color, name, marginX = 5, onPress, testID }): ReactElement => {
    return (
        <Grid noExpand minWidth={0} testID={testID}>
            <Touchable onPress={onPress}>
                <Grid
                    backgroundColor="onyx-opacity-50"
                    borderRadius={13}
                    width={26}
                    height={26}
                    noExpand
                    center
                    marginX={marginX}
                >
                    <FontelloIcon name={name} fontSize={12} color={color} />
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default memo(NavigationBarButtonWithBackground)
